import { render, staticRenderFns } from "./TemplateEditMenu.vue?vue&type=template&id=9dad844c&scoped=true&"
import script from "./TemplateEditMenu.vue?vue&type=script&lang=ts&"
export * from "./TemplateEditMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateEditMenu.vue?vue&type=style&index=0&id=9dad844c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dad844c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListGroup,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
